import Form from 'refactored/features/soForm/steps/card/creditCard/Form/styled';

export default Form;
